import React, { useState } from 'react'
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import RemoveIcon from "../../../images/remove.png"
import PlusIcon from "../../../images/plus_icon.png"
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { GLOBAL_URL } from '../../../API/global';
import { validateDoc, validatePdf } from '../../Helper';
import { DdData } from '../../../Config/Config';
const { DdassistanceMail } = DdData();


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const Documents = ({ formData, setFormData, setDocumentErrors, errors }) => {


    const handleChange = (e) => {
        const { name, value } = e.target;
        const newValue = value.replace(/\D/g, '').slice(0, 10); // Ensure numeric input

        // Prepare an updated form data object
        let updatedFormData = {};

        if (name === "requisite_documents" && (value === 0 || value === "0")) {
            setOpen(true);
            updatedFormData[name] = null;
        } else {
            updatedFormData[name] = newValue;
        }

        // If the field is supposed to be an integer, parse it
        if (["some_integer_field_name_1", "some_integer_field_name_2"].includes(name)) {
            updatedFormData[name] = parseInt(value, 10);
        }

        setFormData(prevData => ({
            ...prevData,
            ...updatedFormData,
        }));

        // Clear the errors for the current field
        errors[name] = "";
        setDocumentErrors(errors);
    };


    const [selectedAttachCopyFile, setSelectedAttachCopyFile] = useState(null);

    const [selectedDeclarationLetterFile, setSelectedDeclarationLetterFile] = useState(null);

    const [selectedSynopsisCopyFile, setSelectedSynopsisCopyFile] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const [selectedDirectorFile, setSelectedDirectorFile] = useState(null);
    const [selectedProducerFile, setSelectedProducerFile] = useState(null);
    const [selectedDetailsCastCrewFile, setSelectedDetailsCastCrewFile] = useState(null);

    const [openRequisiteDocumentsopen, setOpenRequisiteDocumentsopen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [showAuthorisationRemoveButton, setShowAuthorisationRemoveButton] = useState(false);
    const [showDeclarationRemoveButton, setShowDeclarationRemoveButton] = useState(false);
    const [showSynopsisRemoveButton, setShowSynopsisRemoveButton] = useState(false);
    const [showDirectorProfileRemoveButton, setShowDirectorProfileRemoveButton] = useState(false);
    const [showProducerProfileRemoveButton, setShowProducerProfileRemoveButton] = useState(false);
    const [showCastAndCrewRemoveButton, setShowCastAndCrewRemoveButton] = useState(false)


    const handleFileAttachCopyChange = (event) => {
        const file = event.target.files[0];

        const selectedFile = event.target.files[0];
        const validateState = validatePdf(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                authorization_latter: validateState.message
            })
        } else {
            setSelectedAttachCopyFile(file);
            setFormData((prevState) => ({
                ...prevState,
                authorization_latter: file,
                is_authorization_latter: 1,
            }));
            setDocumentErrors({
                authorization_latter: ""
            })
        }

    };

    const handleDeclarationLetter = (event) => {
        const filedeclaration = event.target.files[0];


        const selectedFile = event.target.files[0];
        const validateState = validatePdf(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                declaration_latter: validateState.message
            })
        } else {
            setSelectedDeclarationLetterFile(filedeclaration);
            setFormData((prevState) => ({
                ...prevState,
                declaration_latter: filedeclaration,
                is_declaration_latter: 1,
            }));
            setDocumentErrors({
                declaration_latter: ''
            })
        }
    };


    const handleSynopsisCopyChange = (event) => {
        const fileSynopsis = event.target.files[0];
        const selectedFile = event.target.files[0];
        const validateState = validateDoc(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                synopsis_in_english: validateState.message
            })
        } else {
            setSelectedSynopsisCopyFile(fileSynopsis);
            setShowSynopsisRemoveButton(true);
            setFormData((prevState) => ({
                ...prevState,
                synopsis_in_english: fileSynopsis,
                is_synopsis_in_english: 1,
            }));
            setDocumentErrors({
                synopsis_in_english: ''
            })
        }
    };

    const handleDirectorFileChange = (event) => {
        const fileDirector = event.target.files[0];
        const selectedFile = event.target.files[0];
        const validateState = validateDoc(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                directors_profile: validateState.message
            })
        } else {
            setSelectedDirectorFile(fileDirector);
            setShowDirectorProfileRemoveButton(true);
            setFormData((prevState) => ({
                ...prevState,
                directors_profile: fileDirector,
                is_directors_profile: 1,
            }));
            setDocumentErrors({
                directors_profile: ''
            })
        }


    };

    const handleProducerFileChange = (event) => {
        const fileProducer = event.target.files[0];
        const selectedFile = event.target.files[0];
        const validateState = validateDoc(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                producers_profile: validateState.message
            })
        } else {
            setSelectedProducerFile(fileProducer);
            setFormData((prevState) => ({
                ...prevState,
                producers_profile: fileProducer,
                is_producers_profile: 1,
            }));
            setDocumentErrors({
                producers_profile: ''
            })
        }


    };

    const handleselectedDetailsCastCrewFile = (event) => {
        const fileDetailsCastCrew = event.target.files[0];
        const selectedFile = event.target.files[0];
        const validateState = validateDoc(selectedFile);
        if (!validateState['status']) {
            setDocumentErrors({
                details_of_cast_crew: validateState.message
            })
        } else {
            setSelectedDetailsCastCrewFile(fileDetailsCastCrew);
            setFormData((prevState) => ({
                ...prevState,
                details_of_cast_crew: fileDetailsCastCrew,
                is_details_of_cast_crew: 1,
            }));
            setDocumentErrors({
                details_of_cast_crew: validateState.message
            })
        }
    };



    const handleClose = () => {
        setOpen(false);
    };

    const handleRequisiteDocumentsClickOpen = () => {
        setOpenRequisiteDocumentsopen(true);
    };

    const handleAuthorisationAttachClick = () => {
        setShowAuthorisationRemoveButton(true);
        // document.getElementById('fileInput').click();
    };


    const handleAuthorisationRemoveClick = () => {
        setSelectedAttachCopyFile();
        // setSelectedAttachCopyFile(null);
        setShowAuthorisationRemoveButton(false);
        // You may also want to clear the selected file here if needed
    };

    const handleDeclarationLetterAttachClick = () => {
        setShowDeclarationRemoveButton(true)
    }

    const handleDeclarationLetterRemoveClick = () => {
        // setSelectedDeclarationLetterFile(null)
        setSelectedDeclarationLetterFile()
        setShowDeclarationRemoveButton(false)
    }

    const handleSynopsisAttachClick = () => {
        setShowSynopsisRemoveButton(true)
    }

    const handleSynopsisRemoveClick = () => {
        setSelectedSynopsisCopyFile(null)
        setShowSynopsisRemoveButton(false)
    }

    const handleDirectorProfileAttachClick = () => {
        setShowDirectorProfileRemoveButton(true)
    }

    const handleDirectorProfileRemoveClick = () => {
        setSelectedDirectorFile(null)
        setShowDirectorProfileRemoveButton(false)
    }

    const handleProducerProfileAttachClick = () => {
        setShowProducerProfileRemoveButton(true)
    }

    const handleProducerProfileRemoveClick = () => {
        setShowProducerProfileRemoveButton(false)
        setSelectedProducerFile(null)

    }

    const handleCastAndCrewAttachClick = () => {
        setShowCastAndCrewRemoveButton(true)
    }

    const handleCastAndCrewRemoveClick = () => {
        setShowCastAndCrewRemoveButton(false)
        setSelectedDetailsCastCrewFile(null)

    }



    return (
        <>
            <h4>11. Documents </h4>
            <form>
                <p style={{ fontWeight: "500", color: "#615A5B" }}>A. Upload Documents</p>

                <div className='row'>
                    <div className='col-sm-12 col-lg-12' style={{ color: '#FF0000', fontWeight: "500" }}>
                        <p className='text-uppercase' style={{ color: '#FF0000' }}>Note:</p>
                        <p>1.SYNOPSIS IN ENGLISH (NOT EXCEEDING 200 WORDS)</p>
                        <p>2.PRODUCER(s) PROFILE (NOT EXCEEDING 100 WORDS)</p>
                        <p>3.DIRECTOR(s) PROFILE (NOT EXCEEDING 100 WORDS)</p>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".pdf"
                                    onChange={handleFileAttachCopyChange}
                                    style={{ display: 'none', width: "100%" }}
                                    id="fileInput"
                                    name="authorization_latter"
                                />
                                <label htmlFor="fileInput" style={{ width: "100%", height: "100%" }}>
                                    <TextField
                                        variant="outlined"

                                        label="(a) Authorisation letter in favour of NFDC (FORM - II) in PDF"

                                        value={selectedAttachCopyFile ? selectedAttachCopyFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInput').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px",
                                            // },
                                        }}
                                        fullWidth
                                    //name="authorization_latter"
                                    // value={formData.authorization_latter}
                                    //onChange={handleChange}
                                    />

                                    {formErrors.authorization_latter && (
                                        <p className="text-danger">{formErrors.authorization_latter}</p>
                                    )}
                                    {!formErrors.authorization_latter && errors.authorization_latter && (
                                        <p className="text-danger">{errors.authorization_latter}</p>
                                    )}
                                    {!(formData?.documentData?.[5]) ? <></> : (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[5].file}`}>{formData?.documentData?.[5].name}</a>
                                            </span>
                                        </div>
                                    )}


                                </label>

                            </div>
                            <div className='col-sm-12 col-lg-2 d-flex align-items-center'>
                                <div style={{ width: "100%" }}>
                                    {/* <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#FF0000', width: '100%' }}>
                                        <img src={RemoveIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Remove</p>
                                    </button>

                                    <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'black', width: '100%' }}>
                                            <img src={PlusIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Attach</p>
                                        </button> */}
                                    {/* 
                                    {showAuthorisationRemoveButton ? (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#FF0000', width: '100%' }} onClick={handleAuthorisationRemoveClick}>
                                            <img src={RemoveIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Remove</p>
                                        </button>
                                    ) : (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'black', width: '100%' }} onClick={handleAuthorisationAttachClick}>
                                            <img src={PlusIcon} alt='plus icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Attach</p>
                                        </button>
                                    )} */}


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".pdf"
                                    onChange={handleDeclarationLetter}
                                    style={{ display: 'none', width: "100%" }}
                                    id="fileInputDeclaration"
                                    name='declaration_latter'
                                // name="date_of_completion_production"
                                // value={formData.date_of_completion_production}
                                // onChange={handleChange} 
                                />
                                <label htmlFor="fileInputDeclaration" style={{ width: "100%", height: "100%" }}>
                                    <TextField
                                        variant="outlined"

                                        label="(b) Declaration letter (as per the clause no 6.3.4 in PDF)"

                                        value={selectedDeclarationLetterFile ? selectedDeclarationLetterFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInputDeclaration').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px",
                                            // },
                                        }}
                                        fullWidth
                                    />
                                    {formErrors.declaration_latter && (
                                        <p className="text-danger">{formErrors.declaration_latter}</p>
                                    )}
                                    {!formErrors.declaration_latter && errors.declaration_latter && (
                                        <p className="text-danger">{errors.declaration_latter}</p>
                                    )}
                                    {!(formData?.documentData?.[6]) ? <></> : (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[6].file}`}>{formData?.documentData?.[6].name}</a>
                                            </span>
                                        </div>
                                    )}

                                </label>

                            </div>
                            <div className='col-sm-12 col-lg-2 d-flex align-items-center'>
                                <div style={{ width: "100%" }}>
                                    {/* {showDeclarationRemoveButton ? (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#FF0000', width: '100%' }} onClick={handleDeclarationLetterRemoveClick}>
                                            <img src={RemoveIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Remove</p>
                                        </button>
                                    ) : (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'black', width: '100%' }} onClick={handleDeclarationLetterAttachClick}>
                                            <img src={PlusIcon} alt='plus icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Attach</p>
                                        </button>
                                    )} */}

                                </div>
                            </div>
                            {/* <div className='col-sm-12 col-lg-2 d-flex align-items-center'>
                                <div style={{ width: "100%" }}>
                                    {showRemoveButton ? (
                                        <button
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: 'transparent',
                                                border: 'none',
                                                color: '#FF0000',
                                                width: '100%'
                                            }}
                                            onClick={handleRemoveClick}
                                        >
                                            <RemoveIcon style={{ marginRight: '5px' }} />
                                            <span>Remove</span>
                                        </button>
                                    ) : (
                                        <button
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: 'transparent',
                                                border: 'none',
                                                color: 'black',
                                                width: '100%'
                                            }}
                                            onClick={handleAttachClick}
                                        >
                                            <AttachFileIcon style={{ marginRight: '5px' }} />
                                            <span>Attach</span>
                                        </button>
                                    )}
                                </div>
                            </div> */}

                        </div>
                    </div>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11 mt-4'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".doc,.docx,.xls,.xlsx,.csv"
                                    onChange={handleSynopsisCopyChange}
                                    style={{ display: 'none', width: "100%" }}
                                    id="fileInputSynopsis"
                                    name="synopsis_in_english"
                                />

                                <label htmlFor="fileInputSynopsis" style={{ width: "100%", height: "100%" }}>
                                    <TextField
                                        variant="outlined"

                                        label="(c) Synopsis in English (not exceeding 200 words) in .doc/.docx Format"

                                        value={selectedSynopsisCopyFile ? selectedSynopsisCopyFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInputSynopsis').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px",
                                            // },
                                        }}
                                        fullWidth
                                    />
                                    {formErrors.synopsis_in_english && (
                                        <p className="text-danger">{formErrors.synopsis_in_english}</p>
                                    )}
                                    {!formErrors.synopsis_in_english && errors.synopsis_in_english && (
                                        <p className="text-danger">{errors.synopsis_in_english}</p>
                                    )}
                                    {!(formData?.documentData?.[7]) ? <></> : (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[7]?.file}`}>
                                                    {formData?.documentData?.[7]?.name}
                                                </a>
                                            </span>
                                        </div>
                                    )}
                                </label>
                            </div>
                            <div className='col-sm-12 col-lg-1 d-flex align-items-center'>
                                <div>
                                    {/* Your attach/remove buttons here */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".doc,.docx,.xls,.xlsx"
                                    onChange={handleDirectorFileChange}
                                    style={{ display: 'none', width: "100%" }}
                                    id="fileInputDirector"
                                    name="directors_profile"
                                />
                                <label htmlFor="fileInputDirector" style={{ width: "100%", height: "100%" }}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        label="(d) Director(s) profile (not exceeding 100 words) &  Director(s) note (not exceeding 30 words) in .doc/.docx format"
                                        value={selectedDirectorFile ? selectedDirectorFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInputDirector').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     whiteSpace: 'pre-wrap',
                                            //     wordWrap: 'break-word',
                                            //     overflowWrap: 'break-word',
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px",

                                            // },
                                        }}
                                    />

                                    {formErrors.directors_profile && (
                                        <p className="text-danger">{formErrors.directors_profile}</p>
                                    )}
                                    {!formErrors.directors_profile && errors.directors_profile && (
                                        <p className="text-danger">{errors.directors_profile}</p>
                                    )}
                                    {!(formData?.documentData?.[8]) ? <></> : (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[8].file}`}>
                                                    {formData?.documentData?.[8].name}
                                                </a>
                                            </span>
                                        </div>
                                    )}
                                </label>
                            </div>
                            <div className='col-sm-12 col-lg-2 d-flex align-items-center'>
                                <div>
                                    {/* Your attach/remove buttons here */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11 mt-4'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".doc,.docx,.xls,.xlsx"
                                    onChange={handleProducerFileChange}
                                    style={{ display: 'none', width: "100%" }}
                                    id="fileInputProducer"
                                    name="producers_profile"
                                />

                                <label htmlFor="fileInputProducer" style={{ width: "100%", height: "100%" }}>
                                    <TextField
                                        variant="outlined"

                                        label="(e) Producer(s) profile (not exceeding 100 words) in .doc/.docx format"

                                        value={selectedProducerFile ? selectedProducerFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInputProducer').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px",
                                            // },
                                        }}
                                        fullWidth
                                    />
                                    {formErrors.producers_profile && (
                                        <p className="text-danger">{formErrors.producers_profile}</p>
                                    )}
                                    {!formErrors.producers_profile && errors.producers_profile && (
                                        <p className="text-danger">{errors.producers_profile}</p>
                                    )}

                                    {!(formData?.documentData?.[9]) ? <></> : (
                                        <div>
                                            <span className="Attach_Photo_ID">
                                                <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[9].file}`}>{formData?.documentData?.[9].name}</a>
                                            </span>
                                        </div>
                                    )}

                                </label>


                            </div>
                            <div className='col-sm-12 col-lg-1 d-flex align-items-center'>
                                <div>
                                    {/* {showProducerProfileRemoveButton ? (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#FF0000', width: '100%' }} onClick={handleProducerProfileRemoveClick}>
                                            <img src={RemoveIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Remove</p>
                                        </button>
                                    ) : (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'black', width: '100%' }} onClick={handleProducerProfileAttachClick}>
                                            <img src={PlusIcon} alt='plus icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Attach</p>
                                        </button>
                                    )} */}


                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 col-lg-12 mt-4'>
                        <div className='row'>
                            <div className='col-sm-12 col-lg-11'>
                                <input
                                    type="file"
                                    // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                                    accept=".doc,.docx,.xls,.xlsx"
                                    onChange={handleselectedDetailsCastCrewFile}
                                    style={{ display: 'none' }}
                                    id="fileInputDetailsCastCrew"
                                    name="details_of_cast_crew"
                                />
                                <label htmlFor="fileInputDetailsCastCrew" style={{ width: "100%" }}>
                                    <TextField
                                        variant="outlined"

                                        label="(f) Details of Cast & Crew in .doc/.docx format"

                                        value={selectedDetailsCastCrewFile ? selectedDetailsCastCrewFile.name : ''}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => document.getElementById('fileInputDetailsCastCrew').click()}
                                                        edge="end"
                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            // style: {
                                            //     border: "1px solid #1c5768",
                                            //     borderRadius: "5px",
                                            //     height: "108px"
                                            // },
                                        }}
                                        fullWidth />
                                    {formErrors.details_of_cast_crew && (
                                        <p className="text-danger">{formErrors.details_of_cast_crew}</p>
                                    )}
                                    {!formErrors.details_of_cast_crew && errors.details_of_cast_crew && (
                                        <p className="text-danger">{errors.details_of_cast_crew}</p>
                                    )}

                                </label>
                                {!(formData?.documentData?.[10]) ? <></> : (
                                    <div>
                                        <span className="Attach_Photo_ID">
                                            <a href={`${GLOBAL_URL}downloadfile/dd/${formData.id}/${formData?.documentData?.[10].file}`}>{formData?.documentData?.[10].name}</a>
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className='col-sm-12 col-lg-2 d-flex align-items-center'>
                                <div>
                                    {/* {showCastAndCrewRemoveButton ? (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#FF0000', width: '100%' }} onClick={handleCastAndCrewRemoveClick}>
                                            <img src={RemoveIcon} alt='remove icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Remove</p>
                                        </button>
                                    ) : (
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'black', width: '100%' }} onClick={handleCastAndCrewAttachClick}>
                                            <img src={PlusIcon} alt='plus icon' style={{ marginRight: '5px' }} /><p style={{ margin: 0 }}>Attach</p>
                                        </button>
                                    )} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mt-4'>
                    <p>B. Following must be mailed to <span style={{ color: "#AD4172", fontWeight: "800" }}>{DdassistanceMail} :-</span></p>
                    <div className='row'>
                        <div className='col-sm-12 col-lg-12'>
                            <p>A:- &nbsp;Film stills (5 nos.), 200-300 dpi<span className='text-danger'>*</span></p>
                            <p>B:- &nbsp;Director(s) working stills (2 nos.), 200-300 dpi<span className='text-danger'>*</span></p>
                            <p>C:- &nbsp;Producer(s) still or logo, 200-300 dpi<span className='text-danger'>*</span></p>
                            <p>D:- &nbsp;Posters</p>
                        </div>
                    </div>
                </div>
                <div className='row mt-4'>

                    <div className="col-sm-12 col-lg-12">
                        <React.Fragment>
                            <div>
                                <h6>Whether the requisite documents(s) at serial no. 2- (A) (B) (C) & (D) are sent by email</h6>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="requisite_documents"
                                        id="requisite_documents_yes"
                                        value="1"
                                        checked={formData.requisite_documents == 1}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="requisite_documents_yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="requisite_documents"
                                        id="requisite_documents_no"
                                        value="0"
                                        checked={formData.requisite_documents == 0}
                                        onChange={handleChange}
                                        onClick={handleRequisiteDocumentsClickOpen}
                                    />
                                    <label className="form-check-label" htmlFor="requisite_documents_no">
                                        No
                                    </label>
                                </div>
                                {errors.requisite_documents && (
                                    <p className="text-danger">{errors.requisite_documents}</p>
                                )}
                            </div>
                            <BootstrapDialog
                                onClose={handleClose}
                                aria-labelledby="customized-dialog-title"
                                open={open}
                            >
                                <DialogContent dividers>
                                    <Typography gutterBottom>
                                        Material at serial no 2- (A) (B) (C) & (D) are mandatory to be submitted by email.
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button autoFocus onClick={handleClose}>
                                        Ok
                                    </Button>
                                </DialogActions>
                            </BootstrapDialog>
                        </React.Fragment>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-sm-12 col-lg-12'>
                        <p className='text-uppercase' style={{ color: '#FF0000', fontWeight: "500" }}>NOTE: SOFT COPIES OF THE DOCUMENTS AT SERIAL NO. 1-(A TO F) AND SERIAL NO. 2-(A, B, C, D) MUST BE SENT TO &nbsp;<a href="mailto:{DdassistanceMail}" className='text-lowercase'>{DdassistanceMail}</a>
                        </p>
                    </div>
                </div>
            </form>
        </>
    )
}

export default Documents